module.exports = __webpack_public_path__ + "static/media/presence_management.acf6fa62.svg";